<navaar-header
    [title]="'دیدگاه'"
    [z-index]="2"
>
</navaar-header>
<div id="container-comment-page">
    <div class="container-rating" *ngIf="totalCountComment > 0">
        <div
            id="container-rating"
            *ngIf="rate"
        >
            <div class="wrapper-rate-line">
                <ng-template
                    ngFor
                    [ngForOf]="[1,2,3,4,5]"
                    let-item
                    let-i="index"
                >
                    <ng-container *ngTemplateOutlet="barRating;context:{index: item, rate: rateDic[item]}"></ng-container>
                </ng-template>
            </div>
            <div class="wrapper-rate-star">
                <h1 [textContent]="rate.averageRatingValue"></h1>
                <div class="wrapper-star">
                    <navaar-star-icon
                        [style]="{'width':'14px', 'height': '13px', 'margin':' 0 1px'}"
                        [rate-item]="rate.averageRatingValue | number"
                    ></navaar-star-icon>
                </div>
                <div class="wrapper-rating">
                    <span [textContent]="rate.ratingsQuantity | number"></span>
                    <span>نفر</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div
    class="container-scroll-div"
    style="top: 200px;padding-bottom: 40px;"
>
    <div class="wrapper-scroll-div">
        <ng-template [ngIf]="comment.length > 0" [ngIfElse]="no_comment">
        <section
            Pagination
            (goTo)="goToNextPage($event)"
            [isEnd]="isEnd"
            [page]="pageNumber"
            [disable-when-fetch-data]="isLoading"
            class="container-pagination"
        >
            <ng-template
                ngFor
                [ngForOf]="comment"
                let-item
            >
                <navaar-comment-template [comment]="item" [url]="'/pdp/comment/'+ this.audiobookId +'/'+ this.id +'?title=' + this.audiobookTitle"></navaar-comment-template>
            </ng-template>
        </section>
        </ng-template>
        <ng-template #no_comment><p class="text-no-comment">اولین نفری باشید که دیدگاه خود را ثبت می‌کند</p></ng-template>
    </div>
</div>
<button
    class="send-commnet {{navigationBarService.isShow && playerService.isShowSmallPlayer ? 'has-navigation-bar-with-has-small-player' :
           navigationBarService.isShow ? 'has-navigation-bar' :
           playerService.isPlayWithSmallPlayer ? 'has-small-player' :
           '' }}"
    (click)="showPopupRateToComment()"
>
    ثبت دیدگاه
</button>
<ng-template
    #barRating
    let-index="index"
    let-rate="rate"
>
    <div class="container-show-rate">
        <span [textContent]="index"></span>
        <div class="bar-mode-outter">
            <div
                class="bar-mode-inner"
                [style.width.%]="calculateBarWidth(rate)"
            ></div>
        </div>
        <span [textContent]="rate | number"></span>
    </div>
</ng-template>
<navaar-send-rate-and-comment
    *ngIf="rate"
    [isShowEmptyTemplate]="totalCountComment == 0"
    [audiobook-id]="audiobookId"
    [identifier]="this.id"
    [show]="isShowRate"
    [(rate)]="ratoToComment"
    [title]="audiobookTitle"
    [main-rate]="rate"
    (onSubmit)="onSubmitPopupRateToComment($event)"
></navaar-send-rate-and-comment>
